import React, { useState } from 'react';
import { faqs as initialFaqs, OFFICIAL_SUPPORT_URL } from '../data/faqs';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './FAQ.css';

export default function FAQ({ faqs = initialFaqs, onNavigate }) {
  const [openIndex, setOpenIndex] = useState(null);

  // Show top 4 FAQs on homepage preview
  const previewFaqs = faqs.slice(0, 4);

  const cardRefs = useScrollReveal(previewFaqs.length);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleViewAllFaqs = (e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('/faq');
    } else {
      window.location.hash = '#faq-page';
    }
  };

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="section-header text-center">
          <span className="badge-volt">SUPPORT &amp; HELP</span>
          <h2 className="section-title">FREQUENTLY ASKED QUESTIONS</h2>
          <p className="section-subtitle">
            Find answers to common questions about setting up, charging, and using your Playermaker device.
          </p>
        </div>

        <div className="faq-list">
          {previewFaqs.map((faq, idx) => (
            <div 
              key={faq.id} 
              className={`faq-item card-tech ${openIndex === idx ? 'open' : ''}`}
              ref={(el) => (cardRefs.current[idx] = el)}
              onClick={() => toggleFAQ(idx)}
            >
              <div className="faq-question-row">
                <h3 className="faq-question">{faq.question}</h3>
                <span className="faq-toggle-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="5" x2="12" y2="19" className="vertical-line" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </span>
              </div>
              
              <div className="faq-answer-container">
                <div className="faq-answer" dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
              </div>
            </div>
          ))}
        </div>

        {/* View All FAQs & Support Banner */}
        <div className="faq-preview-actions flex-center" style={{ marginTop: '4.8rem', gap: '1.6rem', flexWrap: 'wrap' }}>
          <a href="/faq" onClick={handleViewAllFaqs} className="btn btn-volt">
            View All FAQs &amp; Support Center &rarr;
          </a>
          <a 
            href={OFFICIAL_SUPPORT_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn btn-outline"
          >
            Playermaker Official Support ↗
          </a>
        </div>
      </div>
    </section>
  );
}
